export const getLevelFormworkBenchLengthMaxValue = (): number => 2;
